const TRICHY_ROUTE_COPY = {
  Chennai: {
    leaveHero:
      'Book a one-way taxi from Trichy to Chennai, then edit pickup or drop if you need a tighter address.',
    returnHero:
      'Leave Chennai for Trichy in a one-way cab. Pickup and drop are set for this inbound leg and stay editable.',
    leaveIntro: [
      'Trichy to Chennai is the eastbound run from Tiruchirappalli toward the capital, often booked after a rail or air arrival when you still need a door-to-door cab rather than another transfer in Chennai. This page is only that Trichy-origin leg.',
      'Pickup starts as Trichy. Change it to Trichy Airport, a hotel or another mapped Tiruchirappalli point if that is where you will wait. Drop starts as Chennai and can be narrowed to an address or Chennai Airport before you estimate.',
      'There is no Trichy–Chennai package fare. After Get Fare Estimate, Sedan, SUV and Crysta show totals from the live mapped drive plus the published tariff and driver bata.',
    ],
    returnIntro: [
      'Chennai to Trichy is the ride into central Tamil Nadu, not a rewrite of the outbound Trichy page. Use it when you are already in Chennai and only need that inland taxi.',
      'The form opens with Chennai pickup and Trichy drop. Replace either field for a neighbourhood, airport or hotel. This URL is not a substitute for the dedicated Chennai to Madurai page.',
      'One Way stays selected so you are not holding a return vehicle in Trichy unless you switch the card to Round Trip.',
    ],
    leaveTravel:
      'You stay in one cab from your Trichy pickup through to Chennai. Distance and time are mapped live for this direction rather than reused from another city’s catalogue.',
    returnTravel:
      'The return starts in Chennai and continues to Trichy as its own mapped drive. This page does not copy the outbound kilometre or treat both directions as the same trip.',
    leaveMeta:
      'Book a one-way Trichy to Chennai taxi with Easy Drop Taxi. Pickup starts in Trichy, drop in Chennai, and the fare uses the live online estimate.',
    returnMeta:
      'Book a one-way Chennai to Trichy taxi with Easy Drop Taxi. Pickup starts in Chennai, drop in Trichy, and both fields stay editable in the existing form.',
    leaveFaqs: [
      {
        question: 'Can I start this Trichy to Chennai taxi from Trichy Airport?',
        answer:
          'Yes. Change pickup to Trichy Airport or another airport address, keep Chennai as drop or edit it, then continue with Get Fare Estimate.',
      },
      {
        question: 'Should I use Trichy or Tiruchirappalli in the pickup field?',
        answer:
          'This page defaults to Trichy because that is the hub spelling. If Google Places suggests Tiruchirappalli for your exact point, you can accept that suggestion. It is still this booking, not a second unpublished route.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I finish this Chennai to Trichy taxi at Trichy Airport?',
        answer:
          'Yes. Keep Chennai as pickup or edit it, change drop to Trichy Airport if that is where you will alight, then estimate as usual.',
      },
      {
        question: 'Is this the same page as Chennai to Madurai?',
        answer:
          'No. Chennai to Madurai already has its own dedicated URL. This page is only Chennai to Trichy.',
      },
    ],
  },
  Bangalore: {
    leaveHero:
      'Travel one way from Trichy to Bangalore in an Easy Drop Taxi cab, with both locations editable before you search.',
    returnHero:
      'Start in Bangalore and book a one-way taxi to Trichy when you are ready to leave Karnataka for central Tamil Nadu.',
    leaveIntro: [
      'Trichy to Bangalore is an interstate outstation drop from Tiruchirappalli into Karnataka. Travellers typically want a single vehicle for the full run rather than changing at a bus stand, and a one-way booking so the cab is not held for a return they will not take.',
      'Pickup defaults to Trichy. Drop defaults to Bangalore. Type a more specific start or finish — a hotel, Bangalore Airport or another mapped point — if that is where you will actually board or alight.',
      'Sample figures on this page appear only after live mapping. They are not a Bangalore package and they are not taken from the Coimbatore–Bangalore catalogue page.',
    ],
    returnIntro: [
      'Bangalore to Trichy is for leaving Karnataka toward Tiruchirappalli. It is a separate landing page because the drive is mapped from Bangalore pickup, not copied from the outbound Trichy start.',
      'Keep or edit Bangalore as pickup and Trichy as drop. Airport pickup in Bangalore is a field edit; that name already exists in Easy Drop Taxi’s city list.',
      'Vehicle rates remain the published per-kilometre tariff plus driver bata. Interstate extras such as permit or toll stay as shown on the review screen.',
    ],
    leaveTravel:
      'The outbound taxi runs from Trichy to Bangalore as one booked vehicle. Distance and time on this page come from the live map for that pickup and drop.',
    returnTravel:
      'You board in Bangalore and continue to Trichy without reusing the outbound map. If mapping is unavailable, use Get Fare Estimate in the booking card.',
    leaveMeta:
      'Book a Trichy to Bangalore one-way taxi with Easy Drop Taxi. Use the online form for pickup, drop and a live fare estimate into Karnataka.',
    returnMeta:
      'Book a Bangalore to Trichy one-way taxi. Reverse-route defaults are pre-filled for leaving Bangalore toward Trichy, and both locations remain editable.',
    leaveFaqs: [
      {
        question: 'Does this page use the Coimbatore to Bangalore taxi URL?',
        answer:
          'No. That pair already has its own Coimbatore slug. This page is only Trichy to Bangalore. Open the Coimbatore landing if you are actually starting in Coimbatore.',
      },
      {
        question: 'Can I finish at Bangalore Airport?',
        answer:
          'Yes. Drop starts as Bangalore. Change it to Bangalore Airport or another mapped terminal address before you estimate.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I start from Bangalore Airport rather than the city name?',
        answer:
          'Yes. Pickup defaults to Bangalore but you can type Bangalore Airport or another mapped point before you estimate.',
      },
      {
        question: 'Is this the same booking as Trichy to Bangalore?',
        answer:
          'No. This page is only the Bangalore to Trichy leg. Use the outbound URL when you are leaving Trichy.',
      },
    ],
  },
  Coimbatore: {
    leaveHero:
      'Book a one-way Trichy to Coimbatore taxi online, then edit pickup or drop if you have a precise address.',
    returnHero:
      'Leave Coimbatore for Trichy in a one-way cab through the same Easy Drop Taxi booking form.',
    leaveIntro: [
      'Trichy to Coimbatore is a westbound taxi from central Tamil Nadu toward Easy Drop Taxi’s home city. It is booked as one vehicle for the full run, not as a local Trichy hire.',
      'Pickup starts in Trichy. Drop starts as Coimbatore. Change pickup if you are leaving from a hotel or Trichy Airport. Change drop if you need Coimbatore Airport or another mapped point.',
      'This pair is not one of the locked Coimbatore-origin catalogue URLs. Fare still follows billed live kilometres, the published vehicle rate and driver bata.',
    ],
    returnIntro: [
      'Coimbatore to Trichy is the eastbound taxi into Tiruchirappalli. Book it when you only need that inbound ride, not a round trip held from Trichy.',
      'The card opens on Coimbatore pickup and Trichy drop. Both fields stay editable. One Way is the default because this page is the reverse leg.',
      'Live mapping for Coimbatore to Trichy is loaded on this page independently. Coimbatore’s 54 destination pages do not include Trichy, so this URL is a separate extra pair.',
    ],
    leaveTravel:
      'You leave Trichy and continue in the same taxi toward Coimbatore. Travel time depends on the live mapped drive and traffic, not a catalogue hour.',
    returnTravel:
      'The inbound taxi starts in Coimbatore and finishes in Trichy. Mapping for this reverse is separate from the Trichy-origin page.',
    leaveMeta:
      'Book a one-way Trichy to Coimbatore taxi with Easy Drop Taxi. Pickup starts in Trichy, drop in Coimbatore, and the fare uses the live mapped estimate.',
    returnMeta:
      'Book a Coimbatore to Trichy one-way taxi with Easy Drop Taxi. Pickup starts in Coimbatore, drop in Trichy, and both locations stay editable.',
    leaveFaqs: [
      {
        question: 'Is this the same as a Coimbatore catalogue route?',
        answer:
          'No. Coimbatore’s locked destination list does not include Trichy. This landing is the Trichy–Coimbatore pair. Open a Coimbatore-origin catalogue page only when you are actually leaving Coimbatore for one of those listed cities.',
      },
      {
        question: 'Can I start from Trichy Airport?',
        answer:
          'Yes. Change pickup to Trichy Airport or another airport address, keep Coimbatore as drop or edit it, then estimate.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I finish this Coimbatore to Trichy taxi at Trichy Airport?',
        answer:
          'Yes. Keep Coimbatore as pickup or edit it, change drop to Trichy Airport if that is where you will alight, then estimate as usual.',
      },
      {
        question: 'Does this reverse page copy the outbound Trichy kilometre?',
        answer:
          'No. Coimbatore to Trichy is mapped on its own when you search. The outbound Trichy to Coimbatore page is a separate URL.',
      },
    ],
  },
  Madurai: {
    leaveHero:
      'Book a one-way taxi from Trichy to Madurai, then edit pickup or drop if you need a more specific address.',
    returnHero:
      'Leave Madurai for Trichy in a one-way cab. Pickup and drop are pre-filled for this return leg and stay editable.',
    leaveIntro: [
      'Trichy to Madurai is a shorter southbound outstation taxi between two temple cities. It is useful when you need a cab that continues after time in Tiruchirappalli rather than a local city hire.',
      'Pickup defaults to Trichy. Drop defaults to Madurai. Type a hotel, junction or Madurai Airport if that is the actual start or finish.',
      'This is not the dedicated Madurai to Chennai page and it is not a Madurai hub substitute. Fare here still uses live mapping plus the published tariff and driver bata.',
    ],
    returnIntro: [
      'Madurai to Trichy is for leaving the temple city toward Tiruchirappalli. It is a separate page because pickup starts in Madurai, not in Trichy, and the drive is mapped in this direction.',
      'Keep or edit Madurai as pickup and Trichy as drop. Airport or hotel edits are field changes, not a second booking system.',
      'One Way is the default so you are not holding a cab in Trichy unless you switch to Round Trip.',
    ],
    leaveTravel:
      'You leave Trichy and continue in the same taxi toward Madurai. Distance on this page comes from the live map for that pickup and drop.',
    returnTravel:
      'You board in Madurai and continue to Trichy as its own mapped drive. This reverse does not reuse the outbound Trichy kilometre.',
    leaveMeta:
      'Book a one-way Trichy to Madurai taxi with Easy Drop Taxi. Pickup starts in Trichy, drop in Madurai, and the fare uses the live online estimate.',
    returnMeta:
      'Book a one-way Madurai to Trichy taxi with Easy Drop Taxi. Pickup starts in Madurai, drop in Trichy, and both fields stay editable.',
    leaveFaqs: [
      {
        question: 'Is this the same as Madurai to Chennai?',
        answer:
          'No. Madurai to Chennai already has a dedicated page. This URL is only Trichy to Madurai.',
      },
      {
        question: 'Can I finish at a specific point in Madurai?',
        answer:
          'Yes. Drop is a starting label. Type a lodging, junction or Madurai Airport before you estimate.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I start from Madurai Airport rather than the city name?',
        answer:
          'Yes. Pickup defaults to Madurai but you can type Madurai Airport or another mapped point before you estimate.',
      },
      {
        question: 'Does this reverse copy the Trichy to Madurai kilometre?',
        answer:
          'No. Madurai to Trichy is mapped when you search on this page. The outbound Trichy URL is a different booking start.',
      },
    ],
  },
  Kanyakumari: {
    leaveHero:
      'Book a one-way Trichy to Kanyakumari taxi, then edit pickup or drop if you need a tighter address.',
    returnHero:
      'Leave Kanyakumari for Trichy in a one-way cab. Pickup and drop are set for this inbound leg and stay editable.',
    leaveIntro: [
      'Trichy to Kanyakumari is a long southbound coastal drop from central Tamil Nadu to the tip of the state. Travellers usually want one vehicle for the full run and a one-way booking so the cab is not held overnight.',
      'Pickup defaults to Trichy. Drop defaults to Kanyakumari — the spelling used on this landing page. Type a hotel or another mapped coastal point if that is where you will alight.',
      'This is not the Coimbatore to kaniyakumari catalogue URL and not the Chennai to Kanyakumari pair. Fare still comes from the live mapped drive, the published tariff and driver bata.',
    ],
    returnIntro: [
      'Kanyakumari to Trichy is for leaving the coast toward Tiruchirappalli. It is a separate landing page because pickup starts in Kanyakumari, not in Trichy.',
      'Keep or edit Kanyakumari as pickup and Trichy as drop. One Way stays selected unless you need Round Trip.',
      'Live mapping for this reverse is independent of the outbound Trichy kilometre and of the Coimbatore kaniyakumari catalogue page.',
    ],
    leaveTravel:
      'You leave Trichy and continue in the same taxi toward Kanyakumari. Distance and time come from the live map for that pickup and drop.',
    returnTravel:
      'You board in Kanyakumari and continue to Trichy as its own mapped drive. This page does not reuse the outbound Trichy kilometre.',
    leaveMeta:
      'Book a one-way Trichy to Kanyakumari taxi with Easy Drop Taxi. Pickup starts in Trichy, drop in Kanyakumari, and the fare uses the live online estimate.',
    returnMeta:
      'Book a one-way Kanyakumari to Trichy taxi with Easy Drop Taxi. Pickup starts in Kanyakumari, drop in Trichy, and both fields stay editable.',
    leaveFaqs: [
      {
        question: 'Does this page use the Coimbatore to Kanyakumari taxi URL?',
        answer:
          'No. Coimbatore’s catalogue uses a kaniyakumari slug. This page is only Trichy to Kanyakumari. Open the Coimbatore landing if you are actually starting in Coimbatore.',
      },
      {
        question: 'Is this the same as Chennai to Kanyakumari?',
        answer:
          'No. Chennai to Kanyakumari already has its own pair URL. Use this page when pickup is Trichy.',
      },
    ],
    returnFaqs: [
      {
        question: 'Can I start from a hotel in Kanyakumari rather than the town name?',
        answer:
          'Yes. Pickup defaults to Kanyakumari but you can type a hotel or another mapped point before you estimate.',
      },
      {
        question: 'Should I use the Trichy to Kanyakumari page for the return?',
        answer:
          'No. Book Kanyakumari to Trichy here. The outbound Trichy page is a different URL with a different pickup default.',
      },
    ],
  },
};

export const getTrichyRouteProfile = (place) => TRICHY_ROUTE_COPY[place] || null;

export const TRICHY_EXTRA_DESTINATIONS = ['Chennai', 'Bangalore', 'Coimbatore', 'Madurai', 'Kanyakumari'];

export const TRICHY_ROUTE_HUB = 'Trichy';
